import { Stack, Box } from 'braid-design-system';
import React from 'react';

import type { PageProps } from 'src/shared/types';

import { StaticPageProvider } from '../../../../components';

import { CardLayout, SEEKInfos, Promos } from './components';
import Intro from './components/Intro/Intro';

const StaticPageProps: PageProps = {
  title: 'Job ads',
  returnUrl: '/products/jobads',
  page: 'job+ads',
  siteSection: 'our+products',
  eventName: 'jobads-page-viewed',
  activeTab: 'Products',
  activeSubTab: 'Job ads',
};

const JobAds = () => (
  <StaticPageProvider {...StaticPageProps}>
    <Box background="surface">
      <Stack space={{ desktop: 'xxlarge', mobile: 'xlarge' }} align="center">
        <Intro />
        <CardLayout />
        <SEEKInfos />
        <Promos />
      </Stack>
    </Box>
  </StaticPageProvider>
);

export default JobAds;
